module.exports = __webpack_public_path__ + "img/pro-head-photo1.dd578ff2.png";